import { useState, useEffect } from "react";

export function useWebcam() {
  const [stream, setStream] = useState(null);
  const [isStreaming, setIsStreaming] = useState(false);
  const [facingMode, setFacingMode] = useState("user");

  useEffect(() => {
    const handleStreamEnded = () => {
      setIsStreaming(false);
      setStream(null);
    };
    if (stream) {
      stream
        .getTracks()
        .forEach((track) => track.addEventListener("ended", handleStreamEnded));
      return () => {
        stream
          .getTracks()
          .forEach((track) =>
            track.removeEventListener("ended", handleStreamEnded),
          );
      };
    }
  }, [stream]);

  const start = async () => {
    const mediaStream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode },
    });
    setStream(mediaStream);
    setIsStreaming(true);
    return mediaStream;
  };

  const stop = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
      setIsStreaming(false);
    }
  };

  const switchCamera = async () => {
    // Stop existing stream
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    
    // Switch camera mode
    const newFacingMode = facingMode === "user" ? "environment" : "user";
    setFacingMode(newFacingMode);
    
    // Start new stream with new facingMode
    const mediaStream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: newFacingMode },
    });
    setStream(mediaStream);
    setIsStreaming(true);
    return mediaStream;
  };

  const result = {
    type: "webcam",
    start,
    stop,
    isStreaming,
    stream,
    switchCamera,
    facingMode,
  };

  return result;
} 